<template>
  <div class="warpper">
    <div class="container">
      <crumb />
      <div class="lg">
        <order-menu :menuType="1" />
        <div class="order_con">
          <div class="con_bar">
            <!-- <div class="con_nav_rec">
              <i></i>
              <em>回收站</em>
            </div> -->
            <ul class="order_menu">
              <li :class="activeName === 0 ? 'on' : ''" @click="navSelect(0)">
                全部
              </li>
              <li :class="activeName === 1 ? 'on' : ''" @click="navSelect(1)">
                待付款
              </li>
              <li :class="activeName === 2 ? 'on' : ''" @click="navSelect(2)">
                待发货
              </li>
              <li :class="activeName === 3 ? 'on' : ''" @click="navSelect(3)">
                待收货
              </li>
              <li :class="activeName === 4 ? 'on' : ''" @click="navSelect(4)">
                待评价
              </li>
            </ul>
            <div class="order_list">
              <div
                class="order_item"
                v-for="(item, index) in ProductList"
                :key="index"
              >
                <div class="item_title">
                  <i>订单号：{{ item.orderNo }}</i>
                  <em>{{ item.customStatusChar }}</em>
                </div>
                <ul
                  class="item_body"
                  v-for="(sec, index) in item.products"
                  :key="index"
                >
                  <li class="td1">
                    <img class="body_img" :src="sec.productImg" alt="" />
                    <div class="body_con">
                      <div class="con_title">
                        {{ sec.productName }}
                      </div>
                      <div class="con_ge">
                        <i>{{ sec.skuName }}</i>
                        <!-- <em>规格：1-2人用小饭煲(机械型)</em> -->
                      </div>
                    </div>
                  </li>
                  <li class="td2">￥{{ sec.productPrice }}</li>
                  <li class="td3">{{ sec.productNum }}</li>
                </ul>
                <div class="item_bottom" v-if="item.status === 10">
                  <div class="order_time">
                    <i>下单时间：{{ item.addTime }}</i>
                  </div>
                  <div class="order_state">
                    <div class="order_text">
                      共{{ item.productCount }}件商品，实付金额：
                    </div>
                    <div class="order_pend">
                      <i>￥{{ item.totalPrice }}</i>
                      <div class="pend_btn cann" @click="cancelHandle(item)">取消订单</div>
                      <div class="pend_btn" @click="paymentHandle(item)">
                        立即支付
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item_bottom" v-if="item.status === 20">
                  <div class="order_time">
                    <i>交易时间：{{ item.addTime }}</i>
                  </div>
                  <div class="order_state">
                    <div class="order_text">
                      共{{ item.productCount }}件商品，实付金额：
                    </div>
                    <div class="order_money">￥{{ item.totalPrice }}</div>
                  </div>
                </div>
                <div class="item_bottom" v-if="item.status === 30">
                  <div class="order_time">
                    <i>交易时间：{{ item.addTime }}</i>
                  </div>
                  <div class="order_state">
                    <div class="order_text">
                      共{{ item.productCount }}件商品，实付金额：
                    </div>
                    <div class="order_pend">
                      <em>￥{{ item.totalPrice }}</em>
                      <div class="pend_btn" @click="receiptHandle(item)">
                        确认收货
                      </div>
                    </div>
                  </div>
                </div>
                       <div class="item_bottom" v-if="item.status===40">
                    <div class="order_time">
                      <i>交易时间：{{ item.addTime }}</i>
                    </div>
                    <div class="order_state">
                      <div class="order_text">共{{ item.productCount }}件商品，实付金额：</div>
                      <div class="order_pend">
                        <em >￥{{ item.totalPrice }}</em>
                        <div class="pend_btn" @click="evaluateHandle(item)">去评价</div>
                      </div>
                    </div>
                  </div>
              </div>
              <el-empty
                description="暂无信息"
                v-if="ProductList.length === 0"
              ></el-empty>
            </div>
          </div>
          <div class="order_pag" v-if="ProductList.length > 0">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="pageSize"
              :total="totalCount"
              @current-change="currentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, onMounted } from 'vue'
// import { useRouter } from 'vue-router'
import { posts } from '../../utils/posts'
import { useStore } from 'vuex'
import crumb from '../../components/bread-crumb/Index.vue'
import orderMenu from '../../components/order_menu.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
export default {
  name: '会员中心订单',
  components: {
    crumb,
    orderMenu
  },
  setup () {
    const store = useStore()
    // const router = useRouter()
    const userInfo = store.state.userInfo
    const activeName = ref(0)
    const status = ref(0) // 订单状态 1:代付款、2:待发货、3:待收货、4:待评价
    const page = ref(1) // 默认页数
    const pageSize = ref(5) // 默认每页数量
    const pageCount = ref(0) // 总页数
    const totalCount = ref(0)
    const ProductList = ref([])
    // 取消订单
    const cancelHandle = (val) => {
      ElMessageBox.confirm(
        '是否删除订单',
        'Warning',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          posts('order/cancel/' + userInfo.uid, { oid: val.id }).then(res => {
            ElMessage({
              type: 'success',
              message: '删除订单成功'
            })
            getOrderHandle()
          })
        })
        .catch(() => {

        })
    }
    // 去评价
    const evaluateHandle = (val) => {

    }
    // 确认收货
    const receiptHandle = (val) => {
      posts('order/sure/' + userInfo.uid, { oid: val.id }).then((res) => {
        ElMessage({
          showClose: true,
          message: '收货成功',
          type: 'success'
        })
        getOrderHandle()
      })
    }
    // 立即支付
    const paymentHandle = (val) => {
      posts('pay/pay/' + userInfo.uid, { orderNo: val.orderNo }).then((res) => {
        location.href = res.data.navUrl
      })
    }
    // 获取分页数量
    const currentChange = (e) => {
      page.value = e
      getOrderHandle()
    }

    // tab 状态
    const navSelect = (tab) => {
      activeName.value = tab
      status.value = tab
      getOrderHandle()
    }
    // 获取订单信息
    const getOrderHandle = () => {
      posts(`order/orders/${userInfo.uid}`, {
        page: page.value,
        pageSize: pageSize.value,
        status: status.value
      }).then((res) => {
        pageCount.value = res.pageCount
        totalCount.value = res.totalCount
        ProductList.value = res.data
      })
    }

    onMounted(() => {
      getOrderHandle()
    })
    return {
      cancelHandle,
      evaluateHandle,
      receiptHandle,
      paymentHandle,
      currentChange,
      ProductList,
      pageCount,
      totalCount,
      status,
      page,
      pageSize,
      activeName,
      navSelect
    }
  }
}
</script>
<style lang="scss">
.container {
  width: 1200px;
}
.order_item {
  margin: 15px 30px 24px 30px;
  border: 1px solid #eeeeee;
  .item_bottom {
    padding: 19px 20px;
    border-top: 1px solid #eeeeee;
    display: flex;
    justify-content: space-between;
    .order_state {
      display: flex;
      align-items: center;
      .order_pend {
        display: flex;
        align-items: center;
        .pend_btn {
          text-align: center;
          padding: 10px 19px;
          color: white;
          background: linear-gradient(90deg, #ff5e41 0%, #fc4353 100%);
          border-radius: 20px;
          cursor: pointer;
          &.cann{
            background: rgba(211, 210, 210, 0.6);
            margin: 0 10px 0 0;
          }
        }
        em {
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 28px;
          margin: 0 16px 0 0;
        }
        i {
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 28px;
          color: #fc4353;
          margin: 0 16px 0 0;
        }
      }
      .order_money {
        font-size: 20px;
        font-weight: 600;
        color: #3e3a39;
      }
      .order_text {
        font-size: 14px;
        font-weight: 400;
        color: #3e3a39;
      }
    }
    .order_time {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      display: flex;
      align-items: center;
    }
  }
  .item_body {
    padding: 0 20px 24px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .td3 {
      flex: 1;
      padding: 0 10px;
      color: #3e3a39;
      text-align: center;
    }
    .td2 {
      flex: 2;
      padding: 0 10px;
      text-align: center;
      color: #3e3a39;
    }
    .td1 {
      flex: 6;
      padding: 0 10px 0 0;
      display: flex;
      .body_con {
        width: 400px;
        .con_ge {
          display: flex;
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          i {
            margin: 0 12px 0 0;
          }
        }
        .con_title {
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          color: #3e3a39;
          margin: 0 0 12px 0;
        }
      }
      .body_img {
        width: 80px;
        height: 80px;
        overflow: hidden;
        margin: 0 12px 0 0;
      }
    }
  }
  .item_title {
    background: #f5f5f5;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    margin: 0 0 21px 0;
    i {
      color: #3e3a39;
    }
    em {
      color: #fc4353;
    }
  }
}
.lg {
  display: flex;
  justify-content: space-between;
  margin: 36px 0 50px 0;
  .order_con {
    width: 880px;
    background: white;
    .order_pag{
      padding:10px 30px;
      display: flex;
      justify-content: flex-end;
    }
    .order_menu {
      display: flex;
      border-bottom: 1px solid #EEEEEE;
      li {
        padding: 0 20px;
        height: 48px;
        line-height: 48px;
        display: inline-block;
        font-size: 18px;
        font-weight: 400;
        cursor: pointer;
        &.on {
          color: #fc4353;
          font-weight: 600;
        }
        &:hover {
          color: #fc4353;
        }
      }
    }
    .con_bar {
      position: relative;
      .order_list {
        min-height: 630px;
      }
      .con_nav_rec {
        position: absolute;
        top: 14px;
        right: 20px;
        display: flex;
        align-items: center;
        cursor: pointer;
        i {
          width: 18px;
          height: 18px;
          background: url(../../assets/images/del.png) no-repeat center;
          background-size: contain;
          margin: 0 2px 0 0;
        }
        em {
          font-size: 18px;
          font-weight: 400;
          color: #3e3a39;
        }
      }
    }
  }
}
</style>
